import { render, staticRenderFns } from "./CRMLawcaseJudgment.vue?vue&type=template&id=67283522&scoped=true&"
import script from "./CRMLawcaseJudgment.vue?vue&type=script&lang=js&"
export * from "./CRMLawcaseJudgment.vue?vue&type=script&lang=js&"
import style0 from "./CRMLawcaseJudgment.vue?vue&type=style&index=0&id=67283522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67283522",
  null
  
)

export default component.exports